import { IWebHistoryItem } from '@/models/web-history.response';
import {
  WEB_HISTORY_CACHE_TTL_MS,
  WEB_HISTORY_STORAGE_KEY,
  WEB_HISTORY_TOP_ITEMS_COUNT,
} from '@/constants/features/web-history-auth';
import { localStorageUtils } from './localStorage';

interface IStoredWebHistory {
  readonly value: {
    readonly suggestions: IWebHistoryItem[];
    readonly topSuggestions: IWebHistoryItem[];
    readonly total: number;
  };
  readonly expiration: number;
}

const isStoredWebHistory = (data: unknown): data is IStoredWebHistory => {
  const candidate = data as Partial<IStoredWebHistory> | null;
  return (
    typeof candidate?.expiration === 'number' &&
    Array.isArray(candidate.value?.suggestions)
  );
};

const readStoredWebHistory = (): unknown => {
  try {
    return localStorageUtils.getObjectItem<unknown>(
      WEB_HISTORY_STORAGE_KEY,
      null
    );
  } catch {
    return null;
  }
};

export const removeWebHistoryFromStorage = (): void => {
  localStorageUtils.removeItem(WEB_HISTORY_STORAGE_KEY);
};

export const getWebHistoryFromStorage = (): IWebHistoryItem[] | null => {
  const stored = readStoredWebHistory();
  if (isStoredWebHistory(stored) && Date.now() < stored.expiration) {
    return stored.value.suggestions;
  }
  removeWebHistoryFromStorage();
  return null;
};

export const saveWebHistoryToStorage = (items: IWebHistoryItem[]): void => {
  const data: IStoredWebHistory = {
    value: {
      suggestions: items,
      topSuggestions: items.slice(0, WEB_HISTORY_TOP_ITEMS_COUNT),
      total: items.length,
    },
    expiration: Date.now() + WEB_HISTORY_CACHE_TTL_MS,
  };
  localStorageUtils.setItem(WEB_HISTORY_STORAGE_KEY, data);
};
